var map = {
	"./3D.svg": "5fc7",
	"./AR.svg": "a26a",
	"./arrowLeft.svg": "497a",
	"./arrowLeftHalfColonialWhite.svg": "703d",
	"./arrowLeftWhite.svg": "d6bb",
	"./arrowRigHthalfColonialWhite.svg": "121c",
	"./arrowRight.svg": "6845",
	"./arrowRightWhite.svg": "0c9f",
	"./back.svg": "7338",
	"./checkmark.svg": "1ec3",
	"./close.svg": "8b1b",
	"./closeRedDamask.svg": "f943",
	"./closeWhite.svg": "e6f6",
	"./comparison.svg": "5d8a",
	"./comparisonHandler.svg": "96b7",
	"./comparisonWhite.svg": "6489",
	"./darkMode.svg": "2efe",
	"./extend.svg": "ec2a",
	"./extendHalfColonialWhite.svg": "8e8a",
	"./fastBackward.svg": "629b",
	"./fastForward.svg": "b58f",
	"./forward.svg": "bdb1",
	"./gridGallery3D.svg": "b9cb",
	"./gridGalleryAR.svg": "20e3",
	"./gridGalleryImage.svg": "cc0b",
	"./gridGalleryMedia.svg": "7244",
	"./gridGallerySound.svg": "f955",
	"./headphone.svg": "d83e",
	"./home.svg": "ac9d",
	"./homeWhite.svg": "ad48",
	"./iframe.svg": "6cf4",
	"./image.svg": "931c",
	"./lightMode.svg": "49ed",
	"./media.svg": "f709",
	"./mediaFullScreen.svg": "b1f3",
	"./mediaMinus.svg": "9768",
	"./mediaPause.svg": "2718",
	"./mediaPlay.svg": "c611",
	"./mediaPlus.svg": "9554",
	"./menu.svg": "d17f",
	"./pause.svg": "644b",
	"./pause2.svg": "40be",
	"./pauseCorrect.svg": "532a",
	"./play.svg": "dab1",
	"./playCorrect.svg": "6c35",
	"./plus.svg": "eb38",
	"./qrCode.svg": "b3b9",
	"./qrCodeWhite.svg": "8134",
	"./replay.svg": "bdf0",
	"./replayCorrect.svg": "1143",
	"./reset.svg": "c680",
	"./rotate.svg": "f109",
	"./search.svg": "d103",
	"./selfieFbShare.svg": "5b18",
	"./selfieMailShare.svg": "90c6",
	"./settings.svg": "9174",
	"./settingsWhite.svg": "f07e",
	"./shareWhite.svg": "6f3f",
	"./sound.svg": "e245",
	"./soundCorrect.svg": "c80a",
	"./soundNotPlayed.svg": "982f",
	"./soundPlayed.svg": "08b8",
	"./soundPlaying.svg": "d377",
	"./stop.svg": "56b4",
	"./timeline.svg": "4c6c",
	"./timelineWhite.svg": "e5a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";